import {
  PORTFOLIO_NAV_ALL_COLLECTIONS_IMAGE,
  PORTFOLIO_NAV_COLLECTION_COVERS,
} from '@/consts/portfolio-nav-images';
import { COLLECTIONS_PATH, PORTFOLIO_PATH, SUB_COLLECTIONS_PATH } from '@/consts/routes';

const collection = slug => `${COLLECTIONS_PATH}/${slug}`;
const subCollection = slug => `${SUB_COLLECTIONS_PATH}/${slug}`;

/** Accessories + Details & Millwork sub-collection slugs per main collection. */
const COLLECTION_SUB_LINK_PREFIX = {
  kitchens: 'kitchen',
  bath: 'bath',
  'custom-millwork': 'custom-millwork',
  wardrobe: 'wardrobe',
};

function collectionAccessoryLinks(collectionSlug) {
  const prefix = COLLECTION_SUB_LINK_PREFIX[collectionSlug];
  return [
    { label: 'Accessories', href: subCollection(`${prefix}-accessories`) },
    { label: 'Details & Millwork', href: subCollection(`${prefix}-details-millwork`) },
  ];
}

export const GALLERY_NAV_HERO_IMAGE = PORTFOLIO_NAV_ALL_COLLECTIONS_IMAGE;

export const GALLERY_NAV_ALL_COLLECTIONS_LINK = {
  label: 'All Collections',
  href: PORTFOLIO_PATH,
};

/** Desktop Gallery mega-menu — image cards with labels and links. */
export const GALLERY_NAV_MEGA_MENU = {
  items: [
    {
      label: GALLERY_NAV_ALL_COLLECTIONS_LINK.label,
      href: GALLERY_NAV_ALL_COLLECTIONS_LINK.href,
      image: GALLERY_NAV_HERO_IMAGE,
    },
    {
      label: 'Kitchens',
      href: collection('kitchens'),
      image: PORTFOLIO_NAV_COLLECTION_COVERS.kitchens,
    },
    {
      label: 'Bathroom Collection',
      href: collection('bath'),
      image: PORTFOLIO_NAV_COLLECTION_COVERS.bath,
    },
    {
      label: 'Custom Millwork',
      href: collection('custom-millwork'),
      image: PORTFOLIO_NAV_COLLECTION_COVERS['custom-millwork'],
    },
    {
      label: 'Wardrobe Collection',
      href: collection('wardrobe'),
      image: PORTFOLIO_NAV_COLLECTION_COVERS.wardrobe,
    },
  ],
  columns: [
    {
      groups: [
        {
          title: 'Kitchens',
          href: collection('kitchens'),
          links: [
            { label: 'Framed Collection', href: subCollection('framed') },
            { label: 'Frameless Collection', href: subCollection('frameless') },
            { label: 'Contemporary Collection', href: subCollection('contemporary') },
            { label: 'Traditional Collection', href: subCollection('traditional') },
            { label: 'Transitional Collection', href: subCollection('transitional') },
            ...collectionAccessoryLinks('kitchens'),
          ],
        },
        {
          title: 'Bathroom Collection',
          href: collection('bath'),
          links: collectionAccessoryLinks('bath'),
        },
      ],
    },
    {
      groups: [
        {
          title: 'Custom Millwork',
          href: collection('custom-millwork'),
          links: [
            { label: 'Home Offices', href: subCollection('home-offices') },
            { label: 'Mud Room/Laundry Room', href: subCollection('mud-room-laundry-room') },
            { label: 'Furniture Pieces', href: subCollection('furniture-pieces') },
            ...collectionAccessoryLinks('custom-millwork'),
          ],
        },
        {
          title: 'Wardrobe Collection',
          href: collection('wardrobe'),
          links: collectionAccessoryLinks('wardrobe'),
        },
      ],
    },
  ],
};

/** Flat links for mobile drawer under Gallery. */
export const GALLERY_NAV_DRAWER_LINKS = [
  { ...GALLERY_NAV_ALL_COLLECTIONS_LINK, variant: 'group' },
  ...GALLERY_NAV_MEGA_MENU.columns.flatMap(column =>
    column.groups.flatMap(group => [
      { label: group.title, href: group.href, variant: 'group' },
      ...group.links.map(link => ({ label: link.label, href: link.href, variant: 'sublink' })),
    ]),
  ),
];

export function getGalleryNavHrefs() {
  const hrefs = new Set([PORTFOLIO_PATH]);
  GALLERY_NAV_MEGA_MENU.items.forEach(item => hrefs.add(item.href));
  GALLERY_NAV_MEGA_MENU.columns.forEach(column => {
    column.groups.forEach(group => {
      hrefs.add(group.href);
      group.links.forEach(link => hrefs.add(link.href));
    });
  });
  return [...hrefs];
}

export { formatCollectionSubNavLabel } from '@/components/website/CollectionSubNavLinks';
